export {
  useDemoProducts,
  getDemoProductById,
  updateDemoProductStock,
} from './useDemoProducts';
export type { DemoProductItem } from './useDemoProducts';

export {
  useDemoCart,
  isProductInDemoCart,
  getDemoCartItemByProductId,
  demoCartIdentityKey,
  normalizeDemoVariantId,
} from './useDemoCart';
export type { DemoCartItemData, DemoAddToCartOptions } from './useDemoCart';

export { useDemoCheckout } from './useDemoCheckout';
